import { render, staticRenderFns } from "./bankItem.vue?vue&type=template&id=be38cda8&scoped=true&"
import script from "./bankItem.vue?vue&type=script&lang=js&"
export * from "./bankItem.vue?vue&type=script&lang=js&"
import style0 from "./bankItem.vue?vue&type=style&index=0&id=be38cda8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be38cda8",
  null
  
)

export default component.exports